<script lang="ts">
  import type { Snippet } from "svelte";
  import type { ClassValue } from "svelte/elements";

  interface Props {
    children?: Snippet;
    class?: ClassValue;
  }

  let { children, class: className }: Props = $props();
</script>

<thead class={["bg-mono-200 dark:bg-mono-100", className]}>{@render children?.()}</thead>
